/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  RatingRef,
  RatingRefOptional,
  RatingRefMetaI,
  RatingRefTrackedI,
} from "./rating-ref";
import { RatingRefTracked, RatingRefMeta } from "./rating-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeBase,
  UnifiedClassTypeBaseOptional,
  UnifiedClassTypeBaseMetaI,
  UnifiedClassTypeBaseTrackedI,
} from "./unified-class-type-base";
import {
  UnifiedClassTypeBaseTracked,
  UnifiedClassTypeBaseMeta,
} from "./unified-class-type-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassTypeRef,
  UnifiedClassTypeRefOptional,
  UnifiedClassTypeRefMetaI,
  UnifiedClassTypeRefTrackedI,
} from "./unified-class-type-ref";
import {
  UnifiedClassTypeRefTracked,
  UnifiedClassTypeRefMeta,
} from "./unified-class-type-ref";

/**
 *
 * @export
 * @interface UnifiedClassTypeFull
 */
export interface UnifiedClassTypeFullOptional extends UnifiedClassTypeBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassTypeFull
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeFull
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeFull
   */
  allowTeacher?: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  teachRating?: RatingRefOptional;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  ratingPrereq?: RatingRefOptional;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  ratingOverkill?: RatingRefOptional;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeFull
   */
  classPrereq?: UnifiedClassTypeRefOptional;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeFull
   */
  classOverkill?: UnifiedClassTypeRefOptional;
}

export interface UnifiedClassTypeFull
  extends
    UnifiedClassTypeFullOptional,
    UnifiedClassTypeBase,
    UnifiedClassTypeRef {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassTypeFull
   */
  typeName?: string;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeFull
   */
  displayOrder?: number;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeFull
   */
  prereqMustComplete?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeFull
   */
  allowTeacher?: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  teachRating?: RatingRef;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  ratingPrereq?: RatingRef;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  ratingOverkill?: RatingRef;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeFull
   */
  classPrereq?: UnifiedClassTypeRef;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeFull
   */
  classOverkill?: UnifiedClassTypeRef;
}

export interface UnifiedClassTypeFullTrackedI extends UnifiedClassTypeBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassTypeFull
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassTypeFull
   */
  displayOrder?: number;
  displayOrderIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeFull
   */
  prereqMustComplete?: boolean;
  prereqMustCompleteIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UnifiedClassTypeFull
   */
  allowTeacher?: boolean;
  allowTeacherIsSet: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  teachRating?: RatingRefTrackedI;
  teachRatingIsSet: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  ratingPrereq?: RatingRefTrackedI;
  ratingPrereqIsSet: boolean;
  /**
   *
   * @type {RatingRef}
   * @memberof UnifiedClassTypeFull
   */
  ratingOverkill?: RatingRefTrackedI;
  ratingOverkillIsSet: boolean;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeFull
   */
  classPrereq?: UnifiedClassTypeRefTrackedI;
  classPrereqIsSet: boolean;
  /**
   *
   * @type {UnifiedClassTypeRef}
   * @memberof UnifiedClassTypeFull
   */
  classOverkill?: UnifiedClassTypeRefTrackedI;
  classOverkillIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassTypeFull",
  function (model: UnifiedClassTypeFull) {
    const transformDatesteachRating = transformDatesMap.get("RatingRef");
    if (transformDatesteachRating && model.teachRating) {
      transformDatesteachRating(model.teachRating);
    }
    const transformDatesratingPrereq = transformDatesMap.get("RatingRef");
    if (transformDatesratingPrereq && model.ratingPrereq) {
      transformDatesratingPrereq(model.ratingPrereq);
    }
    const transformDatesratingOverkill = transformDatesMap.get("RatingRef");
    if (transformDatesratingOverkill && model.ratingOverkill) {
      transformDatesratingOverkill(model.ratingOverkill);
    }
    const transformDatesclassPrereq = transformDatesMap.get(
      "UnifiedClassTypeRef",
    );
    if (transformDatesclassPrereq && model.classPrereq) {
      transformDatesclassPrereq(model.classPrereq);
    }
    const transformDatesclassOverkill = transformDatesMap.get(
      "UnifiedClassTypeRef",
    );
    if (transformDatesclassOverkill && model.classOverkill) {
      transformDatesclassOverkill(model.classOverkill);
    }
  },
);

export type UnifiedClassTypeFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  displayOrder: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prereqMustComplete: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  allowTeacher: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  teachRating: PropertyMeta<RatingRefMetaI>;
  //isDate: false
  //isDatetime: false
  ratingPrereq: PropertyMeta<RatingRefMetaI>;
  //isDate: false
  //isDatetime: false
  ratingOverkill: PropertyMeta<RatingRefMetaI>;
  //isDate: false
  //isDatetime: false
  classPrereq: PropertyMeta<UnifiedClassTypeRefMetaI>;
  //isDate: false
  //isDatetime: false
  classOverkill: PropertyMeta<UnifiedClassTypeRefMetaI>;
}>;

export var UnifiedClassTypeFullMeta: UnifiedClassTypeFullMetaI =
  {} as UnifiedClassTypeFullMetaI;
UnifiedClassTypeFullMeta = typeMeta("UnifiedClassTypeFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  displayOrder: propertyMeta(
    "displayOrder",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  prereqMustComplete: propertyMeta(
    "prereqMustComplete",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  allowTeacher: propertyMeta(
    "allowTeacher",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  teachRating: propertyMeta("teachRating", false, false, false, RatingRefMeta),
  ratingPrereq: propertyMeta(
    "ratingPrereq",
    false,
    false,
    false,
    RatingRefMeta,
  ),
  ratingOverkill: propertyMeta(
    "ratingOverkill",
    false,
    false,
    false,
    RatingRefMeta,
  ),
  classPrereq: propertyMeta(
    "classPrereq",
    false,
    false,
    false,
    UnifiedClassTypeRefMeta,
  ),
  classOverkill: propertyMeta(
    "classOverkill",
    false,
    false,
    false,
    UnifiedClassTypeRefMeta,
  ),
});

const metaI = UnifiedClassTypeFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassTypeRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassTypeRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassTypeBaseMeta]);
  metaI.typeName.inheritedFrom = UnifiedClassTypeBaseMeta.typeName;
  metaI.displayOrder.inheritedFrom = UnifiedClassTypeBaseMeta.displayOrder;
  metaI.prereqMustComplete.inheritedFrom =
    UnifiedClassTypeBaseMeta.prereqMustComplete;
});

export class UnifiedClassTypeFullTracked
  extends UnifiedClassTypeBaseTracked
  implements UnifiedClassTypeFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  displayOrder__I?: number = undefined;
  displayOrderIsSet: boolean = false;
  set displayOrder(v: undefined | number) {
    if (v !== undefined) {
      this.displayOrder__I = v;
      this.displayOrderIsSet = true;
    } else {
      this.displayOrder__I = v || undefined;
      this.displayOrderIsSet = false;
    }
    this.changeTracker = true;
  }
  get displayOrder() {
    return this.displayOrder__I;
  }
  prereqMustComplete__I?: boolean = undefined;
  prereqMustCompleteIsSet: boolean = false;
  set prereqMustComplete(v: undefined | boolean) {
    if (v !== undefined) {
      this.prereqMustComplete__I = v;
      this.prereqMustCompleteIsSet = true;
    } else {
      this.prereqMustComplete__I = v || undefined;
      this.prereqMustCompleteIsSet = false;
    }
    this.changeTracker = true;
  }
  get prereqMustComplete() {
    return this.prereqMustComplete__I;
  }
  allowTeacher__I?: boolean = undefined;
  allowTeacherIsSet: boolean = false;
  set allowTeacher(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowTeacher__I = v;
      this.allowTeacherIsSet = true;
    } else {
      this.allowTeacher__I = v || undefined;
      this.allowTeacherIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowTeacher() {
    return this.allowTeacher__I;
  }
  teachRating__I?: RatingRefTracked = undefined;
  teachRatingIsSet: boolean = false;
  set teachRating(v: undefined | RatingRefTracked) {
    if (v !== undefined) {
      this.teachRating__I = v;
      this.teachRatingIsSet = true;
    } else {
      this.teachRating__I = v || undefined;
      this.teachRatingIsSet = false;
    }
    this.changeTracker = true;
  }
  get teachRating() {
    return this.teachRating__I;
  }
  ratingPrereq__I?: RatingRefTracked = undefined;
  ratingPrereqIsSet: boolean = false;
  set ratingPrereq(v: undefined | RatingRefTracked) {
    if (v !== undefined) {
      this.ratingPrereq__I = v;
      this.ratingPrereqIsSet = true;
    } else {
      this.ratingPrereq__I = v || undefined;
      this.ratingPrereqIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingPrereq() {
    return this.ratingPrereq__I;
  }
  ratingOverkill__I?: RatingRefTracked = undefined;
  ratingOverkillIsSet: boolean = false;
  set ratingOverkill(v: undefined | RatingRefTracked) {
    if (v !== undefined) {
      this.ratingOverkill__I = v;
      this.ratingOverkillIsSet = true;
    } else {
      this.ratingOverkill__I = v || undefined;
      this.ratingOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get ratingOverkill() {
    return this.ratingOverkill__I;
  }
  classPrereq__I?: UnifiedClassTypeRefTracked = undefined;
  classPrereqIsSet: boolean = false;
  set classPrereq(v: undefined | UnifiedClassTypeRefTracked) {
    if (v !== undefined) {
      this.classPrereq__I = v;
      this.classPrereqIsSet = true;
    } else {
      this.classPrereq__I = v || undefined;
      this.classPrereqIsSet = false;
    }
    this.changeTracker = true;
  }
  get classPrereq() {
    return this.classPrereq__I;
  }
  classOverkill__I?: UnifiedClassTypeRefTracked = undefined;
  classOverkillIsSet: boolean = false;
  set classOverkill(v: undefined | UnifiedClassTypeRefTracked) {
    if (v !== undefined) {
      this.classOverkill__I = v;
      this.classOverkillIsSet = true;
    } else {
      this.classOverkill__I = v || undefined;
      this.classOverkillIsSet = false;
    }
    this.changeTracker = true;
  }
  get classOverkill() {
    return this.classOverkill__I;
  }
  constructor(config?: UnifiedClassTypeFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.teachRating?.setIds();

    this.ratingPrereq?.setIds();

    this.ratingOverkill?.setIds();

    this.classPrereq?.setIds();

    this.classOverkill?.setIds();
  }
  assignFrom(
    config: UnifiedClassTypeFullOptional,
    options?: AssignOptions,
  ): UnifiedClassTypeFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (
      config.displayOrder &&
      this.displayOrderApplyFilter(optionsRequired.filter)
    ) {
      this.displayOrder = config.displayOrder;
      if (optionsRequired.unassign) this.displayOrderIsSet = false;
      else this.displayOrderIsSet = true;
    }
    if (
      config.prereqMustComplete &&
      this.prereqMustCompleteApplyFilter(optionsRequired.filter)
    ) {
      this.prereqMustComplete = config.prereqMustComplete;
      if (optionsRequired.unassign) this.prereqMustCompleteIsSet = false;
      else this.prereqMustCompleteIsSet = true;
    }
    if (
      config.allowTeacher &&
      this.allowTeacherApplyFilter(optionsRequired.filter)
    ) {
      this.allowTeacher = config.allowTeacher;
      if (optionsRequired.unassign) this.allowTeacherIsSet = false;
      else this.allowTeacherIsSet = true;
    }
    if (
      config.teachRating &&
      this.teachRatingApplyFilter(optionsRequired.filter)
    ) {
      this.teachRating = new RatingRefTracked(config.teachRating, options);
      if (optionsRequired.unassign) this.teachRatingIsSet = false;
      else this.teachRatingIsSet = true;
    }
    if (
      config.ratingPrereq &&
      this.ratingPrereqApplyFilter(optionsRequired.filter)
    ) {
      this.ratingPrereq = new RatingRefTracked(config.ratingPrereq, options);
      if (optionsRequired.unassign) this.ratingPrereqIsSet = false;
      else this.ratingPrereqIsSet = true;
    }
    if (
      config.ratingOverkill &&
      this.ratingOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.ratingOverkill = new RatingRefTracked(
        config.ratingOverkill,
        options,
      );
      if (optionsRequired.unassign) this.ratingOverkillIsSet = false;
      else this.ratingOverkillIsSet = true;
    }
    if (
      config.classPrereq &&
      this.classPrereqApplyFilter(optionsRequired.filter)
    ) {
      this.classPrereq = new UnifiedClassTypeRefTracked(
        config.classPrereq,
        options,
      );
      if (optionsRequired.unassign) this.classPrereqIsSet = false;
      else this.classPrereqIsSet = true;
    }
    if (
      config.classOverkill &&
      this.classOverkillApplyFilter(optionsRequired.filter)
    ) {
      this.classOverkill = new UnifiedClassTypeRefTracked(
        config.classOverkill,
        options,
      );
      if (optionsRequired.unassign) this.classOverkillIsSet = false;
      else this.classOverkillIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassTypeFullTrackedI {
    const cloned = {} as UnifiedClassTypeFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.displayOrderIsSetDeep() &&
      this.displayOrderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.displayOrderIsSet = true;
      cloned.displayOrder = this.displayOrder;
    } else {
      //cloned.displayOrderIsSet = false
    }
    if (
      this.prereqMustCompleteIsSetDeep() &&
      this.prereqMustCompleteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prereqMustCompleteIsSet = true;
      cloned.prereqMustComplete = this.prereqMustComplete;
    } else {
      //cloned.prereqMustCompleteIsSet = false
    }
    if (
      this.allowTeacherIsSetDeep() &&
      this.allowTeacherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowTeacherIsSet = true;
      cloned.allowTeacher = this.allowTeacher;
    } else {
      //cloned.allowTeacherIsSet = false
    }
    if (
      this.teachRatingIsSetDeep() &&
      this.teachRatingApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.teachRatingIsSet = true;
      cloned.teachRating = this.teachRating?.removeUnset(filter);
    } else {
      //cloned.teachRatingIsSet = false
    }
    if (
      this.ratingPrereqIsSetDeep() &&
      this.ratingPrereqApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingPrereqIsSet = true;
      cloned.ratingPrereq = this.ratingPrereq?.removeUnset(filter);
    } else {
      //cloned.ratingPrereqIsSet = false
    }
    if (
      this.ratingOverkillIsSetDeep() &&
      this.ratingOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ratingOverkillIsSet = true;
      cloned.ratingOverkill = this.ratingOverkill?.removeUnset(filter);
    } else {
      //cloned.ratingOverkillIsSet = false
    }
    if (
      this.classPrereqIsSetDeep() &&
      this.classPrereqApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classPrereqIsSet = true;
      cloned.classPrereq = this.classPrereq?.removeUnset(filter);
    } else {
      //cloned.classPrereqIsSet = false
    }
    if (
      this.classOverkillIsSetDeep() &&
      this.classOverkillApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.classOverkillIsSet = true;
      cloned.classOverkill = this.classOverkill?.removeUnset(filter);
    } else {
      //cloned.classOverkillIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassTypeFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.displayOrderApplyFilter(filter)) this.displayOrderIsSet = false;

    if (!this.prereqMustCompleteApplyFilter(filter))
      this.prereqMustCompleteIsSet = false;

    if (!this.allowTeacherApplyFilter(filter)) this.allowTeacherIsSet = false;

    if (!this.teachRatingApplyFilter(filter)) this.teachRatingIsSet = false;
    this.teachRating?.unassignAll(filter);

    if (!this.ratingPrereqApplyFilter(filter)) this.ratingPrereqIsSet = false;
    this.ratingPrereq?.unassignAll(filter);

    if (!this.ratingOverkillApplyFilter(filter))
      this.ratingOverkillIsSet = false;
    this.ratingOverkill?.unassignAll(filter);

    if (!this.classPrereqApplyFilter(filter)) this.classPrereqIsSet = false;
    this.classPrereq?.unassignAll(filter);

    if (!this.classOverkillApplyFilter(filter)) this.classOverkillIsSet = false;
    this.classOverkill?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.assignId,
      UnifiedClassTypeFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.typeName,
      UnifiedClassTypeFullMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  displayOrderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.displayOrder,
      UnifiedClassTypeFullMeta,
      this.displayOrder,
      this,
    );
  }
  displayOrderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.displayOrderIsSet && this.displayOrderApplyFilter(filter))
      return true;

    return false;
  }
  prereqMustCompleteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.prereqMustComplete,
      UnifiedClassTypeFullMeta,
      this.prereqMustComplete,
      this,
    );
  }
  prereqMustCompleteIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.prereqMustCompleteIsSet &&
      this.prereqMustCompleteApplyFilter(filter)
    )
      return true;

    return false;
  }
  allowTeacherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.allowTeacher,
      UnifiedClassTypeFullMeta,
      this.allowTeacher,
      this,
    );
  }
  allowTeacherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowTeacherIsSet && this.allowTeacherApplyFilter(filter))
      return true;

    return false;
  }
  teachRatingApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.teachRating,
      UnifiedClassTypeFullMeta,
      this.teachRating,
      this,
    );
  }
  teachRatingIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.teachRatingIsSet && this.teachRatingApplyFilter(filter))
      return true;
    return this.teachRating?.anySet(filter) == true;

    return false;
  }
  ratingPrereqApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.ratingPrereq,
      UnifiedClassTypeFullMeta,
      this.ratingPrereq,
      this,
    );
  }
  ratingPrereqIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingPrereqIsSet && this.ratingPrereqApplyFilter(filter))
      return true;
    return this.ratingPrereq?.anySet(filter) == true;

    return false;
  }
  ratingOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.ratingOverkill,
      UnifiedClassTypeFullMeta,
      this.ratingOverkill,
      this,
    );
  }
  ratingOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ratingOverkillIsSet && this.ratingOverkillApplyFilter(filter))
      return true;
    return this.ratingOverkill?.anySet(filter) == true;

    return false;
  }
  classPrereqApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.classPrereq,
      UnifiedClassTypeFullMeta,
      this.classPrereq,
      this,
    );
  }
  classPrereqIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classPrereqIsSet && this.classPrereqApplyFilter(filter))
      return true;
    return this.classPrereq?.anySet(filter) == true;

    return false;
  }
  classOverkillApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassTypeFullMeta.classOverkill,
      UnifiedClassTypeFullMeta,
      this.classOverkill,
      this,
    );
  }
  classOverkillIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.classOverkillIsSet && this.classOverkillApplyFilter(filter))
      return true;
    return this.classOverkill?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.displayOrderIsSetDeep(filter)) return true;
    if (this.prereqMustCompleteIsSetDeep(filter)) return true;
    if (this.allowTeacherIsSetDeep(filter)) return true;
    if (this.teachRatingIsSetDeep(filter)) return true;
    if (this.ratingPrereqIsSetDeep(filter)) return true;
    if (this.ratingOverkillIsSetDeep(filter)) return true;
    if (this.classPrereqIsSetDeep(filter)) return true;
    if (this.classOverkillIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
